/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{convertFromSpatialReferenceUnit as t}from"../../../core/unitUtils.js";import{fromGeometryToGXGeometry as o,getSpatialReference as r}from"../support/jsonConverter.js";function n(n,e={}){const{unit:s}=e;let c=o(n).calculateLength2D();const i=r(n);return c&&s&&i&&(c=t(c,i,s)),c}export{n as execute};
